export default {
	publicInfo:{}
}



// WEBPACK FOOTER //
// ./src/store/mp/wechat/auth/state.js